import React from 'react'
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Home, Privacy, FeatureRequest, ReportBug, Terms, Article, Articles } from './pages'
import styled from 'styled-components'
import { Nav } from './components'

const Hidden = styled.div`
  width: 0px;
  height: 0px;
  overflow: hidden;
`

const Wrap = styled.div`
  padding: 80px 20px;
  max-width: 800px;
  margin: 0 auto;
`

const Field = styled.div`
  padding: 10px;
`

function App() {
  return (
    <>
      <Router>
        <Nav />
        <Route exact path="/" component={Home} />
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/feature-request" component={FeatureRequest} />
        <Route exact path="/submit-bug" component={ReportBug} />
        <Route path="/article/:id/:name" component={Article} />
        <Route path="/articles" component={Articles} />
      </Router>
    </>
  );
}

export default App;
